/*
 * @Author: zhangxiao zhangxiao@chengla.net
 * @Date: 2023-08-21 11:31:54
 * @LastEditors: yangming@chengla.net
 * @LastEditTime: 2025-09-05 10:54:15
 * @FilePath: /enterpriseWeChat_sideBar/src/main.ts
 * @Description:
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { Toast } from "vant";
import { store, key } from "./store";
import { ElInfiniteScroll} from "element-plus";
import "amfe-flexible";
import "./assets/css/index.less";
import "./assets/icons/iconfont.js";
import "./assets/icons/iconfont.css";
import "vant/lib/index.css";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from "element-plus/es/locale/lang/zh-cn";
import Vconsole from "vconsole";
import { uploadFileOSS } from 'chengla-web-ui'
import sa from './utils/saSdkConfig'
process.env.VUE_APP_ENV != "production" && new Vconsole();

const app = createApp(App);
app.component('uploadFileOSS', uploadFileOSS)
//pinia
import { createPinia } from "pinia";
app.use(createPinia());
app.use(store, key);
app.use(router);
app.use(Toast);
app.use(ElInfiniteScroll);
app.use(ElementPlus, {
    locale: zhCn
  })

app.config.globalProperties['$sensors'] = sa

router.beforeEach((to, from, next) => {
  sa.track('$pageview',{
    '$url_path': to.path,
    '$title': to.meta.title
  })
  next()
})
app.mount("#app");
